import { render, staticRenderFns } from "./SyncOpportunitySubmit.vue?vue&type=template&id=6a8128be&scoped=true"
import script from "./SyncOpportunitySubmit.vue?vue&type=script&lang=js"
export * from "./SyncOpportunitySubmit.vue?vue&type=script&lang=js"
import style0 from "./SyncOpportunitySubmit.vue?vue&type=style&index=0&id=6a8128be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8128be",
  null
  
)

export default component.exports